import { fetchJSON } from '../utils/fetch'
import { Service, service, inject } from './di'
import { ConfigService } from './ConfigService'
import MetadataService from './MetadataService'
import { Backflipp } from './BackflippService'
import { LocationService } from './LocationService'
import { FlyerService } from './FlyerService'
import {
    FlyerMetadataJSON,
    MerchantsDetails,
} from '../definitions/BackflippDefinitions'
import { ReleaseService } from './ReleaseService'

@service
export default class MerchantService extends Service {
    @inject configService: ConfigService
    @inject metadataService: MetadataService
    @inject backflippService: Backflipp
    @inject flyerService: FlyerService
    @inject locationService: LocationService
    @inject releaseService: ReleaseService

    /**
     * Takes the category with the most flyers and returns only premium flyers
     * If there is not premium in the top, it takes the next category
     */
    public async getTopCategoryPremiumFlyers(): Promise<FlyerMetadataJSON[]> {
        const { flyers } = await this.flyerService.getFlyersDataJSON(
            this.locationService.postalCode
        )
        const categories = await this.flyerService.getCategories()
        const sortedCategories = [...categories]
            .sort((a, b) => a.count - b.count)
            .slice(0, categories.length - 2)
        let filteredFlyers: FlyerMetadataJSON[] = []
        while (filteredFlyers.length === 0 && sortedCategories.length > 0) {
            const topCategory = sortedCategories.pop()
            filteredFlyers = flyers.filter(
                (flyer) =>
                    flyer.categories.includes(topCategory.name) &&
                    flyer.premium === true
            )
        }
        return filteredFlyers
    }

    public async getMerchantDetails(
        merchantIds: string
    ): Promise<MerchantsDetails> {
        try {
            return this.releaseService.shouldDeprecateBackflippMerchants
                ? await fetchJSON<MerchantsDetails>(
                      `${this.configService.API_SERVER}/merchants/details?ids=${merchantIds}`
                  )
                : await fetchJSON<MerchantsDetails>(
                      `${this.configService.GATEFLIPP_SERVER}/flipp/merchants/details?ids=${merchantIds}&source=flipp_web`
                  )
        } catch (e) {
            return null
        }
    }

    public async getAllMerchants(locale: string): Promise<MerchantsDetails> {
        try {
            return this.releaseService.shouldDeprecateBackflippMerchants
                ? await fetchJSON<MerchantsDetails>(
                      `${this.configService.API_SERVER}/merchants?locale=${locale}`
                  )
                : await fetchJSON<MerchantsDetails>(
                      `${this.configService.GATEFLIPP_SERVER}/flipp/merchants?locale=${locale}&source=flipp_web`
                  )
        } catch (e) {
            return null
        }
    }
}
